import { ChatMessage } from '../types/chat';
import { UserRole } from '../types/user';

export const isSessionAwaitingClientReply = (messages: ChatMessage[]): boolean => {
  if (!messages.length) {
    return true;
  }

  const lastMessage = messages.reduce((latest, message) =>
    new Date(message.created).getTime() > new Date(latest.created).getTime() ? message : latest
  );

  return lastMessage.sender?.role !== UserRole.Client;
};

export const resolveInactivityMessagesEnabled = (
  sessionId: string,
  inactivityMessagesEnabled: boolean | undefined,
  inactivityAutoCloseBySession: Record<string, boolean>
): boolean => inactivityAutoCloseBySession[sessionId] ?? inactivityMessagesEnabled ?? true;
